import { render } from "./NotificationModal.vue?vue&type=template&id=52ee04e8&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=js"
export * from "./NotificationModal.vue?vue&type=script&lang=js"

import "./NotificationModal.vue?vue&type=style&index=0&id=52ee04e8&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52ee04e8"]])

export default __exports__